import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { env } from 'env';

export const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: window.history,
    },
    disableFetchTracking: false,
  },
});

appInsights.loadAppInsights();

appInsights.addTelemetryInitializer((envelope) => {
  if (envelope.tags) {
    envelope.tags['ai.cloud.role'] = env.REACT_APP_DIGIFI_ENVIRONMENT
      ? `Custom Portal Frontend (${env.REACT_APP_DIGIFI_ENVIRONMENT})`
      : 'Custom Portal Frontend';
  }
});

export default appInsights;
